import React from "react";
import "../Css/AboutCTA.css";

const AboutCTA = () => {
  return (
    <section className="about-cta">
      {/* bubbles */}
      <span className="cta-bubble cta-bubble-1"></span>
      <span className="cta-bubble cta-bubble-2"></span>

      <div className="cta-card">
        <h2>Want to Know more About Us</h2>

        <div className="cta-divider"></div>

        <a href="/about-us" className="cta-btn">
          About Us
        </a>
      </div>
    </section>
  );
};

export default AboutCTA;
